// DESCRIPTION: Step 1 — business type. Choice drives page seeding, sample
// event, and downstream defaults. Skippable per-step or via "Skip setup".

import { __ } from '@wordpress/i18n';
import WizardShell from '../components/WizardShell';
import ChoiceCard from '../components/ChoiceCard';

const PERSONA_OPTIONS = [
	{
		id: 'tutor',
		title: 'Tutor / Coach',
		desc: 'Individual teaching and sessions',
	},
	{ id: 'studio', title: 'Studio / Gym', desc: 'Classes and group bookings' },
	{
		id: 'professional',
		title: 'Consultant',
		desc: 'Meetings and appointments',
	},
	{ id: 'other', title: 'Something Else', desc: 'Custom booking needs' },
];

/**
 * @since PBOOKING_SINCE
 *
 * @param {Object}   props
 * @param {string}   props.value
 * @param {Function} props.onChange    (persona) => void
 * @param {Function} props.onBack
 * @param {Function} props.onSkip      Skip this step.
 * @param {Function} props.onSkipSetup Skip the entire setup.
 * @param {Function} props.onContinue
 * @param {number}   props.progress
 * @param {boolean}  props.isLoading
 *
 * @return {JSX.Element}
 */
export default function BusinessTypeStep( {
	value,
	onChange,
	onBack,
	onSkip,
	onSkipSetup,
	onContinue,
	progress,
	isLoading,
} ) {
	return (
		<WizardShell
			stepKey="persona"
			progress={ progress }
			onBack={ onBack }
			onSkip={ onSkip }
			onSkipSetup={ onSkipSetup }
			onContinue={ onContinue }
			continueDisabled={ ! value }
			isLoading={ isLoading }
		>
			<div className="nemtly-wizard-step">
				<h2 className="nemtly-wizard-headline">
					{ __( 'What best describes you?', 'nemtly-booking' ) }
				</h2>
				<p className="nemtly-wizard-lede">
					{ __(
						'We will tailor your experience based on your business type.',
						'nemtly-booking'
					) }
				</p>

				<div className="nemtly-wizard-grid nemtly-wizard-grid--2">
					{ PERSONA_OPTIONS.map( ( option ) => (
						<ChoiceCard
							key={ option.id }
							title={ option.title }
							description={ option.desc }
							isActive={ value === option.id }
							onClick={ () => onChange( option.id ) }
						/>
					) ) }
				</div>
			</div>
		</WizardShell>
	);
}
